import { usePostHog } from "posthog-js/react";

export function useUserAnalyticsService() {
  const posthog = usePostHog();

  function captureUserAction(eventData: { actionType: string | null; actionStatus: string }) {
    captureUserActionPosthog(eventData);
    captureUserActionGoogleAnalytics(eventData);
    captureUserActionFacebook(eventData);
  }

  function captureUserActionPosthog(eventData: { actionType: string | null; actionStatus: string }) {
    posthog?.capture("user_action", {
      action_type: eventData.actionType,
      action_status: eventData.actionStatus,
    });
  }

  function captureUserActionGoogleAnalytics(eventData: { actionType: string | null; actionStatus: string }) {
    // TODO - implement
  }

  function captureUserActionFacebook(eventData: { actionType: string | null; actionStatus: string }) {
    // TODO - implement
  }

  function capturePageView(eventData: { actionGuid: string }) {
    capturePageViewPosthog(eventData);
    capturePageViewGoogleAnalytics(eventData);
    capturePageViewFacebook(eventData);
  }

  function capturePageViewPosthog(eventData: { actionGuid: string }) {
    posthog?.capture("$pageview", { action_guid: eventData.actionGuid });
  }

  function capturePageViewGoogleAnalytics(eventData: { actionGuid: string }) {
    // TODO - implement
  }

  function capturePageViewFacebook(eventData: { actionGuid: string }) {
    // TODO - implement
  }

  function captureOptIn(eventData: { actionGuid: string }) {
    captureOptInPosthog(eventData);
    captureOptInGoogleAnalytics(eventData);
    captureOptInFacebook(eventData);
  }

  function captureOptInPosthog(eventData: { actionGuid: string }) {
    posthog?.capture("explicit_opt_in", { action_guid: eventData.actionGuid });
  }

  function captureOptInGoogleAnalytics(eventData: { actionGuid: string }) {
    // TODO - implement
  }

  function captureOptInFacebook(eventData: { actionGuid: string }) {
    // TODO - implement
  }

  /**
   * @param eventData - donationAmount is captured in decimal representation. e.g. 1.23, rather than in lowest currently unit, 123
   */
  function captureDonation(eventData: { actionGuid: string; donationAmount: number; isRegularDonation: boolean }) {
    captureDonationPosthog(eventData);
    captureDonationGoogleAnalytics(eventData);
    captureDonationFacebook(eventData);
  }

  function captureDonationPosthog(eventData: {
    actionGuid: string;
    donationAmount: number;
    isRegularDonation: boolean;
  }) {
    posthog?.capture("donation", {
      action_guid: eventData.actionGuid,
      donation_amount: eventData.donationAmount,
      is_regular_donation: eventData.isRegularDonation,
    });
  }

  function captureDonationGoogleAnalytics(eventData: {
    actionGuid: string;
    donationAmount: number;
    isRegularDonation: boolean;
  }) {
    // Implementation for Google Analytics donation tracking can go here
  }

  function captureDonationFacebook(eventData: {
    actionGuid: string;
    donationAmount: number;
    isRegularDonation: boolean;
  }) {
    // Implementation for Facebook donation tracking can go here
  }

  return { captureUserAction, capturePageView, captureOptIn, captureDonation };
}
